import React, { useEffect, useMemo, useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedVenue } from '../../../redux/slices/userSlice';
import { fetchEntertainmentData } from '../../../redux/slices/myGymTV/entertainmentSlice';
import { getScrollingMessages } from '../../../redux/slices/myGymTV/scrollingMessagesSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faUserGroup } from '@fortawesome/free-solid-svg-icons';
import './top-nav.scss';
import './venue-select.scss';

const VenueSelect = () => {
    const dispatch = useDispatch();
    const { selectedVenue, initialLoginData } = useSelector((state) => state.user);
    const [searchTerm, setSearchTerm] = useState('');

    const clubs = initialLoginData?.data?.InitialLoginData || [];

    useEffect(() => {
        localStorage.setItem('selectedVenue', JSON.stringify(selectedVenue));
    }, [selectedVenue]);

    const handleSelectVenue = (venue) => {
        dispatch(setSelectedVenue(venue));
        dispatch(fetchEntertainmentData());
        dispatch(getScrollingMessages());
        setSearchTerm('');
    };

    const filteredClubs = useMemo(() => {
        const normalizedSearch = searchTerm.trim().toLowerCase();
        if (!normalizedSearch) return clubs;
        return clubs.filter((club) => {
            const clubName = club.ClubName?.toLowerCase() || club.clubName?.toLowerCase() || '';
            const zoneName = club.ZoneName?.toLowerCase() || club.zoneName?.toLowerCase() || '';
            return clubName.includes(normalizedSearch) || zoneName.includes(normalizedSearch);
        });
    }, [clubs, searchTerm]);

    return (
        <Dropdown onToggle={(isOpen) => !isOpen && setSearchTerm('')}>
            <Dropdown.Toggle id="venue-dropdown" variant="primary">
                {selectedVenue
                    ? (selectedVenue.ClubName || selectedVenue.clubName)
                    : 'Select'}
            </Dropdown.Toggle>

            <Dropdown.Menu className="dropdown-venue-select-us">
                <div
                    className="dropdown-venue-search-wrapper"
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="flex-row">
                        <FontAwesomeIcon
                            className="venue-select-search-icon"
                            icon={faMagnifyingGlass}
                        />
                        <Form.Control
                            type="text"
                            placeholder="Search venues..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="dropdown-venue-search"
                        />
                    </div>
                </div>

                <div className="dropdown-venue-items">
                    {filteredClubs.length > 0 ? (
                        filteredClubs.map((club, index) => (
                            <Dropdown.Item
                                key={`${club.ClubName || club.clubName}-${club.ZoneName || club.zoneName}-${index}`}
                                onClick={() => handleSelectVenue(club)}
                                className="dropdown-venue-select-us-item"
                            >
                                <div className="flex-row">
                                    <FontAwesomeIcon className="venue-icon" icon={faUserGroup} />
                                    <div className="venue-info-grp">
                                        <div>{club.ClubName || club.clubName}</div>
                                        <div className="dropdown-venue-select-us-subtext">
                                            {club.ZoneName || club.zoneName}
                                        </div>
                                    </div>
                                </div>
                            </Dropdown.Item>
                        ))
                    ) : (
                        <div className="dropdown-venue-no-results">No venues found</div>
                    )}
                </div>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default VenueSelect;